import { API } from 'aws-amplify';

class ConstantsService {
    getConstants = async () => {
        var ReturnObj = [];
        await API.get('IAPI', 'Constants/constantList/')
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );

        return ReturnObj;
    }
    deleteConstant = async (id) => {
        var ReturnObj = {};
        await API.post('IAPI', 'Constants/delete/', {
            'queryStringParameters': {
                'id': id
            },
            body: {}
        })
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    };
    updateConstant = async (constant) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                id: constant.id,
                ConstantName: constant.ConstantName,
                ConstantValue: constant.ConstantValue,
                ConstantDescription: constant.ConstantDescription
                }
        }
        await API.post('IAPI', 'Constants/update/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    };
    addConstant = async (constant) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                ConstantName: constant.ConstantName,
                ConstantValue: constant.ConstantValue,
                ConstantDescription: constant.ConstantDescription
                   }
        }
        await API.post('IAPI', 'Constants/add/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    };
}

export default new ConstantsService();